import { Injectable, inject } from '@angular/core';

import { LocalStorageHelperService } from 'src/app/shared/services/local-storage-helper.service';

const SHOW_ALL_COMPANIES_KEY_PREFIX = 'selectCompany.showAllCompanies.';

@Injectable({
  providedIn: 'root',
})
export class CompanyTreeViewModeService {
  private readonly localStorageHelper = inject(LocalStorageHelperService);

  read(userCompanyId: string): boolean {
    const key = this.storageKey(userCompanyId);
    if (!key) {
      return false;
    }

    try {
      return this.localStorageHelper.get(key) === true;
    } catch {
      return false;
    }
  }

  write(userCompanyId: string, showAll: boolean): void {
    const key = this.storageKey(userCompanyId);
    if (!key) {
      return;
    }

    try {
      this.localStorageHelper.set(key, showAll);
    } catch {
      return;
    }
  }

  private storageKey(userCompanyId: string): string | null {
    if (typeof userCompanyId !== 'string' || userCompanyId.trim() === '') {
      return null;
    }

    return `${SHOW_ALL_COMPANIES_KEY_PREFIX}${userCompanyId}`;
  }
}
